import Slider from "react-slick";

export default function Section3() {
  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <div className="w-full Section3 bg-[#F5F5F5] py-[20px] overflow-hidden">
      <div className="w-full section3-container">
        <Slider {...settings}>
          <div className="">
            <img
              src="assets/slider-image-mobile-app.JPG"
              className="w-full mx-auto md:w-[750px] lg:w-[970px] xl:w-[1170px]"
            />
          </div>

          <div>
            <iframe
              src="https://www.youtube.com/embed/C5dadO8czJQ"
              title="Money Back Guarantee Star Cast Reviews about Mean3 marketing agency"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
              className="w-[75%] mx-auto h-[200px] xs:w-[420px] object-cover xs:h-[360px] md:w-[640px] md:h-[480px]"
            ></iframe>
          </div>

          <div>
            <iframe
              src="https://www.youtube.com/embed/A1futGekjHs"
              title="Money Back Guarantee Star Cast Reviews about Mean3 marketing agency"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
              className="w-[75%] mx-auto h-[200px] xs:w-[420px] object-cover xs:h-[360px] md:w-[640px] md:h-[480px]"
            ></iframe>
          </div>

          <div>
            <iframe
              src="https://www.youtube.com/embed/xUfpvS4aS6E"
              title="Money Back Guarantee Star Cast Reviews about Mean3 marketing agency"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
              className="w-[75%] mx-auto h-[200px] xs:w-[420px] object-cover xs:h-[360px] md:w-[640px] md:h-[480px]"
            ></iframe>
          </div>

          <div>
            <iframe
              src="https://www.youtube.com/embed/JzK7C-SkOMY"
              title="Money Back Guarantee Star Cast Reviews about Mean3 marketing agency"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
              className="w-[75%] mx-auto h-[200px] xs:w-[420px] object-cover xs:h-[360px] md:w-[640px] md:h-[480px]"
            ></iframe>
          </div>

          <div>
            <video
              className="w-[75%] mx-auto h-[200px] xs:w-[420px] xs:h-[360px] md:w-[640px] md:h-[480px] object-cover"
              controls
            >
              <source
                src="https://mean3.com/wp-content/uploads/2024/07/Zashko-Testimonial.mp4"
                type="video/mp4"
              />
            </video>
          </div>
        </Slider>
      </div>
    </div>
  );
}
